import { Routes } from '@angular/router';
import { VerlanglijstComponent } from './pages/verlanglijst/verlanglijst.component';

export const routes: Routes = [

  {
    path: '',
    component: VerlanglijstComponent
  },
  {
    path: 'lootjestrekken',
    loadComponent: () => import('./pages/lootjestrekken/lootjestrekken.component').then(c => c.LootjestrekkenComponent)
  },
  {
    path: 'help',
    loadComponent: () => import('./pages/help/help.component').then(c => c.HelpComponent)
  },
  {
      path: 'voorwaarden',
      loadComponent: () => import('./pages/voorwaarden/voorwaarden.component').then(c => c.VoorwaardenComponent)
  },
  {
      path: 'privacy',
      loadComponent: () => import('./pages/privacy/privacy.component').then(c => c.PrivacyComponent)
  },
  {
      path: 'cookiebeleid',
      loadComponent: () => import('./pages/cookie-policy/cookie-policy.component').then(c => c.CookiePolicyComponent)
  },
  {
      path: 'baby',
      loadComponent: () => import('./pages/baby/baby.component').then(c => c.BabyComponent)
  },
  {
      path: 'sinterklaas',
      loadComponent: () => import('./pages/sinterklaas/sinterklaas.component').then(c => c.SinterklaasComponent)
  },
  {
      path: 'kerst',
      loadComponent: () => import('./pages/kerst/kerst.component').then(c => c.KerstComponent)
  },
  {
      path: 'verjaardagslijstje',
      loadComponent: () => import('./pages/verjaardag/verjaardag.component').then(c => c.VerjaardagComponent)
  },
  {
      path: 'bruiloft',
      loadComponent: () => import('./pages/bruiloft/bruiloft.component').then(c => c.BruiloftComponent)
  },
  {
      path: 'meer',
      loadComponent: () => import('./pages/meer/meer.component').then(c => c.MeerComponent)
  },
  {
    path: 'blog',
    loadChildren: () => import('./pages/blogs/routes').then(mod => mod.BLOG_ROUTES)
  },
  {
      path: 'webwinkels',
      loadComponent: () => import('./pages/webshops/webshops.component').then(c => c.WebshopsComponent)
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./auth/routes').then(
        (mod) => mod.AUTH_ROUTES
      ),
  },
  
  {
    path: 'catalogus',
    loadComponent: () => import('./catalog/catalog.component').then(c => c.CatalogComponent)
  },
  {
    path: 'lootjes',
    loadChildren: () =>
      import('./lootjes/routes').then(
        (mod) => mod.LOOTJES_ROUTES
      )
    },
    {
      path: 'afgestreept/:key',
      loadComponent: () => import('./giver-reserved/giver-reserved.component').then(c => c.GiverReservedComponent)
    },
    {
      path: 'uitnodiging/:key',
      loadComponent: () => import('./invitation/invitation.component').then(c => c.InvitationComponent) 
    },

  {
    path: '',
    loadChildren: () =>
      import('./member/routes').then(
        (mod) => mod.MEMBER_ROUTES
      ),
  },

  {
    path: '',
    loadChildren: () => import('./contact/routes').then(mod => mod.CONTACT_ROUTES)
  },
  {
      path: ':list',
      loadComponent: () => import('./giver/giver.component').then(c => c.GiverComponent)
  },

];
